import { getClinicStructuredData } from "./clinic";

export function getDallasHighlandParkStructuredData() {
  return getClinicStructuredData("highland-park-place", [
    { name: "Locations", path: "/locations/" },
    { name: "Texas", path: "/locations/texas/" },
    { name: "Dallas Highland Park", path: "/locations/texas/dallas-highland-park/" },
  ]);
}
